import { render, staticRenderFns } from "./indexdel2.vue?vue&type=template&id=8c43e93e&scoped=true&"
import script from "./indexdel2.vue?vue&type=script&lang=js&"
export * from "./indexdel2.vue?vue&type=script&lang=js&"
import style0 from "./indexdel2.vue?vue&type=style&index=0&id=8c43e93e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c43e93e",
  null
  
)

export default component.exports